import {useEffect, useState} from 'react';

/** Half a minute: ages read to the minute, so this is the coarsest tick nobody would notice. */
const DEFAULT_TICK_MS = 30 * 1000;

/**
 * A clock that ticks, for anything showing an age rather than an instant.
 *
 * Relative times are computed at render from the current moment, so they only change when something
 * re-renders — and refetching does not guarantee that. React Query shares structure between responses: a
 * poll returning JSON identical to what is cached keeps the SAME object, deliberately, so nothing
 * downstream re-renders. A check-in posted a moment ago would stay "just now" forever.
 *
 * So the clock is the state. Call it ONCE per screen and pass the value down: one timer per card would
 * be a dozen timers all doing the same thing at the same time.
 */
export const useNow = (tickMs: number = DEFAULT_TICK_MS): number => {
    const [now, setNow] = useState(() => Date.now());

    useEffect(() => {
        const timer = setInterval(() => setNow(Date.now()), tickMs);

        return () => clearInterval(timer);
    }, [tickMs]);

    return now;
};
